import styled from 'styled-components';
import type { PtoVolumePosition } from '@shared/api';
import { rowEstimates } from '../rdGaps/logic';
import type { VolumeCellContext } from './columns';
import { fmtQty } from './format';

/** Пояснение под числом графы количества: мелко, с переносом (и в виде
 *  «Сводно ▶»). */
export const QtyNote = styled.div<{ $estimate?: boolean }>`
  margin-top: 2px;
  max-width: 240px;
  margin-left: auto;
  font-size: 12px;
  line-height: 1.3;
  white-space: normal;
  text-align: right;
  cursor: help;
  color: ${({ theme, $estimate }) =>
    $estimate ? theme.colors.status.warning : theme.colors.text.secondary};
`;

interface Props {
  position: PtoVolumePosition;
  ctx: VolumeCellContext;
}

/** «Кол-во»: число РД как есть. Под ним у ЛКМ — площадь покрытия с учётом слоёв
 *  («покрытие 186,92 м² (2 слоя)», признак отбора `coating`; формула — в
 *  подсказке) и оценка по нормам ГЭСН у строки СП, где включён анализ
 *  комплектности («≈ X кг — оценка по ГЭСН …, сверить, не для заказа»). Ни то,
 *  ни другое в суммы не входит. */
export function QtyCell({ position: p, ctx }: Props) {
  const coating = ctx.marks.get(p.id)?.coating;
  const estimates = rowEstimates(p, ctx.gaps);
  return (
    <>
      {fmtQty(p.quantity)}
      {coating && <QtyNote title={coating.text}>{coating.label}</QtyNote>}
      {estimates.map((e, i) => (
        <QtyNote key={i} $estimate title={e.detail}>
          {e.text}
          {e.byAi && ' (норма выбрана ИИ)'}
          {e.stale && ' — прогон устарел, проверьте по нормам заново'}
        </QtyNote>
      ))}
    </>
  );
}
